import { Cls, Emojis } from 'app/constants';
import { useAppDispatch } from 'app/hooks';
import { setRouteToLoadAfterAuth } from 'app/slices/AppUiSlice';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/Routes';

export const AuthIndexRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const cPath = window.location.pathname;
    const msg = `${Emojis.eyes} %c AuthIndexRoute %c cPath %c ${cPath} %c`;

    // Save current route before redirecting to login (only if not already on auth)
    if (cPath === AppRoutes.Home) return;

    if (!cPath.startsWith(AppRoutes.Auth)) {
      dispatch(setRouteToLoadAfterAuth(window.location.pathname));
    }

    console.log(msg, Cls.Loc, '', Cls.Msg, '');

    // Always redirect to login page when hitting auth index
    navigate('/auth/login', { replace: true });
  }, [dispatch, navigate]);

  return <></>;
};

export default AuthIndexRoute;
